import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useStore } from "../../../helpers";
import { fetchSrChats, type SrSavedChat } from "./sr-chat-list";

type Props = {
    activeId?: string;
    onOpen: (id: string) => void;
};

const formatWhen = (ms: number) => {
    if (!ms) return "";
    return new Date(ms).toLocaleString();
};

export const SrChatListPanel: React.FC<Props> = ({ activeId, onOpen }) => {
    const rootStore = useStore();
    const { projectid } = useParams();
    const [chats, setChats] = useState<SrSavedChat[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const pid = parseInt(projectid || "", 10);
        if (!pid) {
            setLoading(false);
            return;
        }
        let alive = true;
        setLoading(true);
        fetchSrChats(rootStore.apiRequestHandler, pid)
            .then((rows) => {
                if (alive) setChats(rows);
            })
            .catch(() => {
                if (alive) setChats([]);
            })
            .finally(() => {
                if (alive) setLoading(false);
            });
        return () => {
            alive = false;
        };
    }, [projectid, rootStore]);

    if (loading) {
        return <p className="px-1 text-xs text-slate-500">Loading chats…</p>;
    }
    if (!chats.length) {
        return (
            <p className="px-1 text-xs text-slate-500">No saved chats yet.</p>
        );
    }
    return (
        <div className="space-y-1">
            {chats.map((chat) => {
                const on = chat.conversation_id === activeId;
                return (
                    <button
                        key={chat.conversation_id}
                        type="button"
                        onClick={() => onOpen(chat.conversation_id)}
                        className={`w-full rounded-xl border px-3 py-2.5 text-left transition ${
                            on
                                ? "border-[#3A80F4]/40 bg-[#3A80F4]/10"
                                : "border-slate-200/80 bg-white hover:bg-slate-50"
                        }`}
                    >
                        <p className="truncate text-sm font-medium text-slate-800">
                            {chat.title}
                        </p>
                        <p className="text-[11px] text-slate-400">
                            {formatWhen(chat.timestamp)}
                        </p>
                    </button>
                );
            })}
        </div>
    );
};
